// frontend/src/modules/funcionarios/components/FuncionarioForm.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaSave, FaTimes } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';

function FuncionarioForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formData, setFormData] = useState({
    nome_completo: '',
    cpf: '',
    rg: '',
    data_nascimento: '',
    endereco: '',
    numero: '',
    complemento: '',
    cidade: '',
    estado: '',
    telefone: '',
    email: '',
    ref1_nome: '',
    ref1_telefone: '',
    ref2_nome: '',
    ref2_telefone: '',
    cargo: '',
    salario: '',
    data_admissao: '',
    carteira_trabalho: '',
    pis_pasep: '',
    banco: '',
    agencia: '',
    conta: '',
    ativo: true
  });

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const token = localStorage.getItem('token');
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  const empresaId = usuario?.empresa_id || 1;

  useEffect(() => {
    if (id) {
      fetchFuncionario();
    }
  }, [id]);

  const fetchFuncionario = async () => {
    setLoading(true);
    try {
      const response = await fetch(`/api/funcionarios/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erro ao buscar funcionário');
      const data = await response.json();
      setFormData({
        ...data,
        data_nascimento: data.data_nascimento ? data.data_nascimento.split('T')[0] : '',
        data_admissao: data.data_admissao ? data.data_admissao.split('T')[0] : '',
        salario: data.salario || ''
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.nome_completo || formData.nome_completo.trim() === '') {
      setError('Nome completo é obrigatório');
      return;
    }
    if (!formData.cpf || formData.cpf.trim() === '') {
      setError('CPF é obrigatório');
      return;
    }
    if (!formData.data_admissao) {
      setError('Data de admissão é obrigatória');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const url = id 
        ? `/api/funcionarios/${id}`
        : `/api/empresa/${empresaId}/funcionarios`;
      
      const method = id ? 'PUT' : 'POST';

      const dados = {
        nome_completo: formData.nome_completo,
        cpf: formData.cpf,
        rg: formData.rg || null,
        data_nascimento: formData.data_nascimento || null,
        endereco: formData.endereco || null,
        numero: formData.numero || null,
        complemento: formData.complemento || null,
        cidade: formData.cidade || null,
        estado: formData.estado || null,
        telefone: formData.telefone || null,
        email: formData.email || null,
        ref1_nome: formData.ref1_nome || null,
        ref1_telefone: formData.ref1_telefone || null,
        ref2_nome: formData.ref2_nome || null,
        ref2_telefone: formData.ref2_telefone || null,
        cargo: formData.cargo || null,
        salario: parseFloat(formData.salario) || 0,
        data_admissao: formData.data_admissao,
        carteira_trabalho: formData.carteira_trabalho || null,
        pis_pasep: formData.pis_pasep || null,
        banco: formData.banco || null,
        agencia: formData.agencia || null,
        conta: formData.conta || null,
        ativo: formData.ativo !== undefined ? formData.ativo : true
      };

      console.log('📤 Enviando dados:', dados);

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(dados)
      });

      const data = await response.json();
      console.log('📥 Resposta:', data);

      if (!response.ok) {
        throw new Error(data.error || (id ? 'Erro ao atualizar' : 'Erro ao criar'));
      }

      setSuccess(id ? '✅ Funcionário atualizado!' : '✅ Funcionário criado!');
      setTimeout(() => navigate('/funcionarios'), 1500);
    } catch (err) {
      console.error('❌ Erro:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading && id) {
    return <div style={{ textAlign: 'center', padding: '50px' }}>🔄 Carregando...</div>;
  }

  return (
    <div style={{ 
      maxWidth: '900px', 
      margin: '0 auto', 
      padding: isMobile ? '10px' : '20px' 
    }}>
      {/* Cabeçalho */}
      <div style={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between', 
        alignItems: isMobile ? 'stretch' : 'center', 
        marginBottom: '20px',
        gap: '10px'
      }}>
        <h2 style={{ margin: 0, fontSize: isMobile ? '20px' : '28px' }}>
          {id ? '✏️ Editar Funcionário' : '📝 Novo Funcionário'}
        </h2>
        <button 
          onClick={() => navigate('/funcionarios')} 
          style={{ 
            padding: isMobile ? '8px 16px' : '8px 16px', 
            backgroundColor: '#6c757d', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer',
            fontSize: isMobile ? '13px' : '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            justifyContent: 'center',
            width: isMobile ? '100%' : 'auto'
          }}
        >
          <FaTimes /> Voltar
        </button>
      </div>

      {/* Mensagens */}
      {error && (
        <div style={{ 
          backgroundColor: '#ffebee', 
          padding: '10px', 
          borderRadius: '4px', 
          color: '#c62828', 
          marginBottom: '15px',
          fontSize: isMobile ? '13px' : '14px'
        }}>
          ❌ {error}
        </div>
      )}
      {success && (
        <div style={{ 
          backgroundColor: '#e8f5e9', 
          padding: '10px', 
          borderRadius: '4px', 
          color: '#2e7d32', 
          marginBottom: '15px',
          fontSize: isMobile ? '13px' : '14px'
        }}>
          ✅ {success}
        </div>
      )}

      {/* Formulário */}
      <form onSubmit={handleSubmit} style={{ 
        backgroundColor: 'white', 
        padding: isMobile ? '15px' : '20px', 
        borderRadius: '8px', 
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)' 
      }}>
        <h3 style={{ fontSize: isMobile ? '16px' : '18px' }}>📋 Dados Pessoais</h3>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', 
          gap: isMobile ? '10px' : '15px' 
        }}>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Nome Completo *</label>
            <input 
              name="nome_completo" 
              value={formData.nome_completo} 
              onChange={handleChange} 
              required 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>CPF *</label>
            <input 
              name="cpf" 
              value={formData.cpf} 
              onChange={handleChange} 
              required 
              placeholder="000.000.000-00" 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>RG</label>
            <input 
              name="rg" 
              value={formData.rg} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Data de Nascimento</label>
            <input 
              name="data_nascimento" 
              value={formData.data_nascimento} 
              onChange={handleChange} 
              type="date" 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Telefone</label>
            <input 
              name="telefone" 
              value={formData.telefone} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Email</label>
            <input 
              name="email" 
              value={formData.email} 
              onChange={handleChange} 
              type="email" 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
        </div>

        <h3 style={{ marginTop: '20px', fontSize: isMobile ? '16px' : '18px' }}>📍 Endereço</h3>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', 
          gap: isMobile ? '10px' : '15px' 
        }}>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Endereço</label>
            <input 
              name="endereco" 
              value={formData.endereco} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Número</label>
            <input 
              name="numero" 
              value={formData.numero} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Complemento</label>
            <input 
              name="complemento" 
              value={formData.complemento} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Cidade</label>
            <input 
              name="cidade" 
              value={formData.cidade} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Estado</label>
            <input 
              name="estado" 
              value={formData.estado} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
        </div>

        <h3 style={{ marginTop: '20px', fontSize: isMobile ? '16px' : '18px' }}>📞 Referências</h3>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', 
          gap: isMobile ? '10px' : '15px' 
        }}>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Referência 1 - Nome</label>
            <input 
              name="ref1_nome" 
              value={formData.ref1_nome} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Telefone Referência 1</label>
            <input 
              name="ref1_telefone" 
              value={formData.ref1_telefone} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Referência 2 - Nome</label>
            <input 
              name="ref2_nome" 
              value={formData.ref2_nome} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Telefone Referência 2</label>
            <input 
              name="ref2_telefone" 
              value={formData.ref2_telefone} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
        </div>

        <h3 style={{ marginTop: '20px', fontSize: isMobile ? '16px' : '18px' }}>💼 Dados Trabalhistas</h3>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', 
          gap: isMobile ? '10px' : '15px' 
        }}>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Cargo</label>
            <input 
              name="cargo" 
              value={formData.cargo} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Salário (R$)</label>
            <input 
              name="salario" 
              value={formData.salario} 
              onChange={handleChange} 
              type="number" 
              step="0.01" 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Data de Admissão *</label>
            <input 
              name="data_admissao" 
              value={formData.data_admissao} 
              onChange={handleChange} 
              type="date" 
              required
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Carteira de Trabalho</label>
            <input 
              name="carteira_trabalho" 
              value={formData.carteira_trabalho} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>PIS/PASEP</label>
            <input 
              name="pis_pasep" 
              value={formData.pis_pasep} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Ativo</label>
            <input 
              name="ativo" 
              checked={formData.ativo} 
              onChange={handleChange} 
              type="checkbox" 
              style={{ width: '20px', height: '20px' }} 
            />
          </div>
        </div>

        <h3 style={{ marginTop: '20px', fontSize: isMobile ? '16px' : '18px' }}>🏦 Dados Bancários</h3>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr', 
          gap: isMobile ? '10px' : '15px' 
        }}>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Banco</label>
            <input 
              name="banco" 
              value={formData.banco} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Agência</label>
            <input 
              name="agencia" 
              value={formData.agencia} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
          <div>
            <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Conta</label>
            <input 
              name="conta" 
              value={formData.conta} 
              onChange={handleChange} 
              style={{ 
                width: '100%', 
                padding: '8px', 
                marginTop: '5px', 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }} 
            />
          </div>
        </div>

        <button 
          type="submit" 
          disabled={loading} 
          style={{ 
            marginTop: '20px', 
            padding: isMobile ? '8px 20px' : '10px 30px', 
            backgroundColor: '#007bff', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer',
            fontSize: isMobile ? '13px' : '14px',
            width: isMobile ? '100%' : 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: 'center'
          }}
        >
          <FaSave /> {loading ? 'Salvando...' : id ? 'Atualizar Funcionário' : 'Salvar Funcionário'}
        </button>
      </form>
    </div>
  );
}

export default FuncionarioForm;